<template>
  <img
    :src="guest.icon || guest.default_icon"
    class="rounded-circle img-fluid" />
</template>

<script>
export default {
  props: ['guest'],
}
</script>

<style scoped>
</style>
